import { Grid, Typography } from '@mui/material';
import ScannerAnimation from '~/components/ScannerAnimation';
import { Link } from '~/components/Link';

export default function LoadingResults() {
  return (
    <Grid
      container
      item
      xs={true}
      data-testid="loading-results"
      className="right-column-loading-results"
      pt={1}
      alignContent={'start'}
      sx={{ transition: 'all 0.2s ease-in-out' }}
      textAlign={'center'}>
      <Grid item xs={12} p={4}>
        <Typography variant="h4" textAlign={'center'}>
          Searching millions of websites...
        </Typography>
        <Typography variant="body1" textAlign={'center'} mt={1}>
          Our crawlers render and analyze millions of websites to find you
          accurate results.
          <br />
          <br />
          Need help? Email our team at{' '}
          <Link href="mailto:support@nerdydata.com" target="_blank">
            support@nerdydata.com
          </Link>
        </Typography>
      </Grid>
      <Grid item xs={12} mt={2} px={4} textAlign={'center'}>
        <ScannerAnimation />
      </Grid>
    </Grid>
  );
}
